import { combineReducers } from "redux";
import airportData from "./airportReducer";
import scheduleData from "./scheduleReducer";
import serviceLevelData from './serviceLevelReducer';
import serviceLevelsContentData from "./serviceLevelContentReducer";
import shipmentData from './shipmentReducer';
import shipmentDetails from './shipmentDetailsReducer';
import facilitiesData from './facilitiesReducer';
import holidayHoursData from './holidayHoursReducer';
import facilitiesMetaData from './facilitiesMetaReducer';
import formsData from './formsReducer';
import newsData from './newsReducer';
import customerTestimonialsData from './customerTestimonialsReducer';
import awardsData from './awardsReducer';
import interlineOperatorsData from './interlineOperatorsReducer';
import pressReleasesData from './pressReleasesReducer';
import shipmentDataByAccountNumber from './shipmentByAccountNumberReducer';
import carouselData from './carouselReducer';
import shippingAdvisoryData from './shippingAdvisoryReducer';
import trainingVideosData from './trainingVideosReducer';
import scanStatusData from './scanStatusReducer';
import scanDetailsData from './scanDetailsReducer';
import sitemapData from './sitemapReducer';
import nonRevAndRevFacilitiesReducer from "./nonRevAndRevFacilitiesReducer";

export default combineReducers({
    airportData: airportData,
    scheduleData: scheduleData,
    serviceLevelData: serviceLevelData,
    serviceLevelsContentData: serviceLevelsContentData,
    shipmentData: shipmentData,
    shipmentDetails: shipmentDetails,
    scanStatusData: scanStatusData,
    scanDetailsData: scanDetailsData,
    facilitiesData: facilitiesData,
    holidayHoursData: holidayHoursData,
    facilitiesMetaData: facilitiesMetaData,
    formsData: formsData,
    newsData: newsData,
    customerTestimonialsData: customerTestimonialsData,
    awardsData: awardsData,
    interlineOperatorsData: interlineOperatorsData,
    pressReleasesData: pressReleasesData,
    shipmentDataByAccountNumber: shipmentDataByAccountNumber,
    carouselData: carouselData,
    shippingAdvisoryData: shippingAdvisoryData,
    trainingVideosData: trainingVideosData,
    sitemapData: sitemapData,
    nonRevAndRevFacilitiesData: nonRevAndRevFacilitiesReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js